module.exports = {
      id: "game-shop-usage",
      viewBox: "0 0 48.679 33.19",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#game-shop",
      toString: function () {
        return this.url;
      }
    }